export default __webpack_public_path__ + "static/media/icon-info-panel-2.b520b8ea.svg";